<template>
    <div class="home-sales-section" v-if="salesItems != null">
        <div class="container container-title" v-if="indexPage != null">
            <div class="section-title">
                <h2>{{ indexPage.sales_filter_title }}</h2>
            </div>
        </div>
        <salesFilter v-if="filterCMSparams != null"></salesFilter>
        <salesFilterCount v-if="!isMobileChecker"></salesFilterCount>
        <div class="container">
            <transition name="fade" mode="out-in">
                <div class="sales-items-mainpage" v-if="salesItemsAnimate">
                    <div class="sale-item" v-for="(item, index) in salesItems">
                        <saleItem :salesArr="item" :saleItemIndex="index" :saleItemsParentPage="'promo'"></saleItem>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    import saleItem from '@/components/sales-page/sale-item.vue'
    import salesFilter from '@/components/filters/sales-projects/sales-filter.vue'
    import salesFilterCount from '@/components/filters/sales-projects/sales-filter-counter.vue'
    export default {
        name: 'home-sales-section',
        components: {
            svgIcon,
            saleItem,
            salesFilter,
            salesFilterCount,
        },
        data () {
            return {
                dataArr: null,
                globalLang: window.GlobalLang, 
                swiperOption: {
                    
                },
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            salesItems: 'loadSalesItems',
            salesItemsAnimate: 'loadSalesItemsAnimate',
            filterCMSparams: 'loadFilterCMSparams',
            filterSalesDataBase: 'loadFilterSalesData',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-sales.scss';
    @import '@/styles/components/home-page/respond/home-sales-respond.scss';
    // @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>